module.exports = __webpack_public_path__ + "static/media/video-extra.4557f988.svg";